import React from "react";
import PropTypes from "prop-types";
import { ClassRegistrationCheckoutProvider } from "../ClassRegistrationCheckoutContext";
import CheckoutBody from "./CheckoutBody";

export default function ClassRegistrationCheckout(props) {
  return (
    <ClassRegistrationCheckoutProvider config={props}>
      <CheckoutBody />
    </ClassRegistrationCheckoutProvider>
  );
}

ClassRegistrationCheckout.propTypes = {
  classInstance: PropTypes.shape({
    name: PropTypes.string.isRequired,
    venueName: PropTypes.string,
    instructorFirstName: PropTypes.string,
    groupDiscountOffered: PropTypes.bool,
    groupDiscountThreshold: PropTypes.number,
    groupDiscountPercentage: PropTypes.string,
    unavailableMessage: PropTypes.string,
  }).isRequired,
  initialQuantity: PropTypes.number.isRequired,
  maxQuantity: PropTypes.number.isRequired,
  quotes: PropTypes.arrayOf(PropTypes.object).isRequired,
  currencyCode: PropTypes.string.isRequired,
  ordersUrl: PropTypes.string.isRequired,
  placeOrderUrl: PropTypes.string,
  initialAttendee: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  holdExpiresAt: PropTypes.string,
  classUrl: PropTypes.string.isRequired,
  catalogUrl: PropTypes.string,
  classCard: PropTypes.shape({
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
    description: PropTypes.string,
    chips: PropTypes.arrayOf(PropTypes.string).isRequired,
    meta: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
  stripePublishableKey: PropTypes.string,
  stripeConnectedAccountId: PropTypes.string,
  turnstileSiteKey: PropTypes.string,
  marketingOptinText: PropTypes.string,
  googleTrackingIds: PropTypes.arrayOf(PropTypes.string),
  analyticsPageLocation: PropTypes.string,
  analyticsItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    venueName: PropTypes.string,
  }),
};
